import { isDefaultBrand } from '../constants/brand';

export const AMEX_BRAND = 'amex';

export function isAmexBrand(brand?: string): boolean {
  return (brand ?? '').toLowerCase() === AMEX_BRAND;
}

export function getExpectedCvvLengths(brand?: string): number[] {
  if (isAmexBrand(brand)) return [4];
  if (isDefaultBrand(brand)) return [3, 4];
  return [3];
}

export function isValidCvv(raw: string, brand?: string): boolean {
  const digits = (raw ?? '').replace(/\D/g, '');
  return getExpectedCvvLengths(brand).includes(digits.length);
}
